module.exports = __webpack_public_path__ + "static/media/leftArrow.58f169dd.svg";